import Vue from 'vue'
import Vuex from 'vuex'
import * as config from "@/config/config";
import { iState, iStateUserData } from "@/types"

Vue.use(Vuex)

const state: iState = {
  app_settings: config.initial_app_settings,
  user: {
    loggedIn: false,
    email: "",
    data: null
  }
};

export default new Vuex.Store({
  state,
  getters: {
    user(state: iState) {
      return state.user
    },
    isLoggedInUser(state: iState) {
      return state && state.user && state.user.loggedIn
    },
    isAdmin(state: iState) {
      return state && state.user && state.user.loggedIn && state.user.data && state.user.data.admin
    },
    app_settings(state: iState) {
      return state.app_settings
    }
  },
  mutations: {
    SET_LOGGED_IN(state: iState, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state: iState, data) {
      state.user.data = data;
      state.user.email = data && data.email ? data.email : ""
    },
    SET_VOLUNTEER_REGISTRATION(state: iState, data) {
      state.user.data.registeredvolunteer = true;
    },
    SET_APPLICATION_CONFIG(state: iState, data) {
      state.app_settings = data;
    }
  },
  actions: {
    updateApplicationSettings({ commit }, data) {
      commit("SET_APPLICATION_CONFIG", data);
    },
    updateVolunteerRegistration({ commit }, data) {
      commit("SET_VOLUNTEER_REGISTRATION", data);
    },
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        const userObject: iStateUserData = {
          uid: user.uid || "",
          email: user.email,
          fullname: user.fullname || user.displayname || user.displayName,
          firstname: user.firstname || "",
          lastname: user.lastname || "",
          displayName: user.displayName || user.displayname || user.fullname,
          photoURL: user.photoURL || '',
          admin: user.admin,
          moderator: user.moderator,
          verifiedvolunteer: user.verifiedvolunteer,
          registeredvolunteer: user.registeredvolunteer
        };
        commit("SET_USER", userObject);
      } else {
        commit("SET_USER", null);
      }
    }
  },
  modules: {
  }
})
